import { createAxiosInstance } from "./axiosInstance";
import {
  AppAdtopiaToken,
  AppPostCodeSingleApi,
  AppEmailValidateSingleApi,
  AppApiUrl,
  AppSinglePointPhoneValidationURL,
  AppT2aCheckSingleEndpointURL,
  AppBudsSingleApi,
  AppGmailWebhookApi,
  AppPersonVerifySingleEndpointURL,
} from "../Constants/EnvConstants";

export const Api = createAxiosInstance({
  baseURL: AppApiUrl,
  token: AppAdtopiaToken,
  timeout: 30000,
});

export const CommonEndApi = createAxiosInstance({
  baseURL: AppPostCodeSingleApi,
  token: AppAdtopiaToken,
  timeout: 30000,
});

export const CommonEmailValidateApi = createAxiosInstance({
  baseURL: AppEmailValidateSingleApi,
  token: AppAdtopiaToken,
  timeout: 30000,
});

export const IdUploadApi = createAxiosInstance({
  baseURL: AppApiUrl,
  token: AppAdtopiaToken,
  timeout: 30000,
});

export const CommonPhoneValidation = createAxiosInstance({
  baseURL: AppSinglePointPhoneValidationURL,
  token: AppAdtopiaToken,
  timeout: 30000,
});

export const T2aValidationApi = createAxiosInstance({
  baseURL: AppT2aCheckSingleEndpointURL,
  token: AppAdtopiaToken,
  timeout: 30000,
});

export const UserVerifyApi = createAxiosInstance({
  baseURL: AppPersonVerifySingleEndpointURL,
  token: AppAdtopiaToken,
  timeout: 30000,
});

export const BudsApi = createAxiosInstance({
  baseURL: AppBudsSingleApi,
  token: AppAdtopiaToken,
  timeout: 30000,
});

export const GmailWebhookApi = createAxiosInstance({
  baseURL: AppGmailWebhookApi,
  timeout: 6000,
});

export const CommonEmailValidateApiTimeDelay = createAxiosInstance({
  baseURL: "https://dev.app.leadfinery.com/api/emvs037/dev/v1",
  token: AppAdtopiaToken,
  timeout: 3000,
});

export const ApiTimeDelay = createAxiosInstance({
  baseURL: "https://dev.api.themoneysolicitor.com",
  token: AppAdtopiaToken,
  timeout: 3000,
});

export const WebBookErrorPage = createAxiosInstance({
  baseURL:
    "https://chat.googleapis.com/v1/spaces/AAAAFvlTyDY/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=2ZvN8b6fvNGbDKV1lEiU8iyjETFq-XrwKD7rG5c3qhs",
  timeout: 6000,
});
